
export default function Contact() {
  return (
    <footer id="contact" className="bg-[#1a1f36] text-white py-20 px-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start justify-between mb-16">
          <h2 className="text-3xl font-serif font-semibold">BRAZDA DOO</h2>
          <p className="text-[#b0b0b0] text-base">Get in touch with us</p>
        </div>

        <div className="grid grid-cols-3 gap-16 mb-20">
          <div>
            <h3 className="text-xl font-bold mb-6">Location</h3>
            <div className="space-y-3 text-[#b0b0b0]">
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line text-lg mt-1"></i>
                <span>Address: TRSCANSKA 62</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-building-line text-lg mt-1"></i>
                <span>City: Beograd (Zemun)</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-mail-line text-lg mt-1"></i>
                <span>Zip: 200452</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-global-line text-lg mt-1"></i>
                <span>Country: Serbia</span>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-6">Contact</h3>
            <div className="space-y-3 text-[#b0b0b0]">
              <p className="flex items-start gap-2">
                <i className="ri-mail-line text-lg mt-1"></i>
                <span>Email: info@brazdadoo.com</span>
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-phone-line text-lg mt-1"></i>
                <span>Number: +1 5822344424</span>
              </p>
            </div>
          </div>

          <div className="text-right">
            <p className="text-2xl font-serif mb-2">© BRAZDA DOO 2025</p>
            <p className="text-sm text-[#b0b0b0]">All rights reserved</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-16 items-center">
          <div className="rounded-2xl overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/6285c3d485d3b26156a4a6006923a796.jpg"
              alt="iOS Device Showcase"
              className="w-full h-[280px] object-cover"
            />
          </div>
          
          <div>
            <p className="text-4xl font-serif leading-relaxed text-white">
              Developing the future<br />of mobile applications
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-[#b0b0b0] hover:text-white transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
